/* eslint-disable ember/use-ember-data-rfc-395-imports */
import { type ModelRegistry } from 'ember-data/model';

import ApplicationAdapter from './application';

interface Query {
  adapterOptions?: {
    locationId: string;
  };
}

export default class VisitorProfileAdapter extends ApplicationAdapter {
  urlForQuery<K extends keyof ModelRegistry>(query: Query, modelName: K): string {
    if (query.adapterOptions?.locationId) {
      const locationId = query.adapterOptions.locationId;
      delete query.adapterOptions; // Clean up so it doesn't go in query params
      return `${this.buildURL()}/locations/${locationId}/visitor-profiles`;
    }

    return super.urlForQuery(query, modelName);
  }
}
